const state = {
  expos: []
}

const getters = {
  allExpo (state) {
    return this.expos
  }
}

const actions = {
  setExpos (context, params) {
    context.commit('SETEXPOS', params)
  }
}

const mutations = {
  SETEXPOS (state, params) {
    state.expos = params
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/expo.js